module.exports = __webpack_public_path__ + "static/media/sub-header.24ef5645.jpg";